import { generateUtilityClass, generateUtilityClasses } from '../className';
export function getListItemUtilityClass(slot) {
  return generateUtilityClass('JoyListItem', slot);
}
const listItemClasses = generateUtilityClasses('JoyListItem', ['root', 'startAction', 'endAction', 'nested', 'nesting', 'sticky']);
export default listItemClasses;